<template>
  <div class="teacher-biometric-courses navigation-top-app">
    <navigation-top-app :app="app" :back="iframe ? null : back">
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.app.teacher.biometric.course.list.title }}
        </div>
      </template>
    </navigation-top-app>
    <div id="teacher-biometric-courses-content" :class="{'with-action': showAll}">
      <loader-dot v-if="courses.loading" :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
      <div class="courses" v-else-if="courses.data.length > 0">
        <div class="course" v-for="course in courses.data" v-bind:key="course.reference">
          <div v-on:click="openBiometricCourse(course.id)">
            <div class="course-data">
              <small>{{ course.reference }}</small>
              <span>{{ course.name }}</span>
            </div>
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>
      </div>
      <div id="courses-empty" v-else>
        {{ offline ? app.strings.app.teacher.biometric.course.list.offline : app.strings.app.teacher.biometric.course.list.empty }}
      </div>
    </div>
    <div class="bottom-action" v-if="showAll">
      <button class="h-button w-100" v-on:click="openBiometricCourse('all')">
        {{ app.strings.app.teacher.biometric.course.list.all }} ({{ courses.data.length }})
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-teacher-biometric-courses-view',
  components: {
  },
  data () {
    return {
      iframe: false,
      offline: false,
      pendingAll: false,
      courses: {
        loading: false,
        data: []
      }
    }
  },
  computed: {
    // With a single course it adds nothing, but records saved offline from
    // this screen are kept under "all" and can only be sent from there.
    showAll () {
      return !this.courses.loading && (this.courses.data.length > 1 || this.pendingAll)
    }
  },
  props: [
    'app'
  ],
  mounted () {
    try {
      this.pendingAll = JSON.parse(localStorage['app-teacher-course-students-pending-all']).length > 0
    } catch (e) {
      this.pendingAll = false
    }

    this.biometricCourseReadAll()
    
    this.iframe = this.$route.query.iframe === true || this.$route.query.iframe === 'true'
  },
  methods: {
    biometricCourseReadAll () {
      if (this.courses.loading) {
        return
      }

      this.courses.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.biometric.course.read.all,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.courses.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.courses.data = response.body.data.courses !== null ? response.body.data.courses : []
            localStorage['app-teacher-courses'] = JSON.stringify(this.courses.data)
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'biometric-course-read-all', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.courses.loading = false
        // Without connection, the last list read; there may be none yet.
        try {
          this.courses.data = JSON.parse(localStorage['app-teacher-courses'])
        } catch (e) {
          this.courses.data = []
        }
        this.offline = this.courses.data.length === 0
      })
    },
    back () {
      this.$router.push({name: 'app.teacher.home', query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
    },
    openBiometricCourse (id) {
      this.$router.push({name: 'app.teacher.biometric.course', params: {id: id}, query: {origin: 'app', navigationLeft: 'false', iframe: this.iframe, token: this.app.token}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#teacher-biometric-courses-content {
  padding: 72px 0 24px;
  box-sizing: border-box;
}

#teacher-biometric-courses-content.with-action {
  padding-bottom: 96px;
}

.courses {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.course {
  min-width: 0;
  padding: 0;
}

.course > div {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
  padding: 12px 14px;
  box-sizing: border-box;
}

.course-data {
  flex: 1;
  min-width: 0;
}

.course-data > small {
  display: block;
  color: #2071b7;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.course-data > span {
  display: block;
  margin-top: 2px;
  color: #1f2a37;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: break-word;
}

.course > div > svg {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 13px;
}

#teacher-biometric-courses-content #courses-empty {
  margin: 0;
  padding: 14px;
  border-radius: 16px;
  background-color: #FFFFFF;
  color: #64748b;
  font-size: 14px;
  text-align: center;
}

@media (min-width: 768px) {
  .courses {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  #teacher-biometric-courses-content {
    padding-top: 92px;
  }
}
</style>
